import { Helmet } from 'react-helmet';

import Adventures from './Adventures';
import Confetti from './Confetti';
import Footer from './Footer';
import LanguageManager from './LanguageManager';
import Menu from './Menu/index';
import Stories from './Stories';
import Subscribe from './Subscribe';
import Summary from './Summary/index';
import TopModule from './TopModule';

import ErrorBoundary from '@shared/ErrorBoundary';

const pageDesc =
  'UEFA Playmakers is a sports activity like no other that delivers a fun and safe introduction to learning football, for 5 - 8 year old girls, through movement, play and the magic of Disney stories';

const Main = () => (
  <>
    <Helmet>
      <title>Playmakers | UEFA.com</title>
      <meta name='description' content={pageDesc} />
    </Helmet>
    <ErrorBoundary>
      <LanguageManager />
      <Confetti />
      <Menu />
      <TopModule />
      <Summary />
      <Subscribe />
      <Adventures />
      <Stories />
      <Footer />
    </ErrorBoundary>
  </>
);

export default Main;
